import { Card } from "antd";
import styled from "styled-components";

export const ListCart = styled(Card)`
  width: 50%;
  margin-left: 15%;
`;
export const OrderHistoryCard = styled(Card)`
  min-height: 70vh;
`;
